// extracted by mini-css-extract-plugin
export default {"container":"wO-z","dimension":"xO-z","dimensionLabels":"yO-z"};